import { get, patch } from './client.js';

export const getPreferences = (orgId) => get(`/orgs/${orgId}/notifications`);
export const updatePreferences = (orgId, body) => patch(`/orgs/${orgId}/notifications`, body);
